<template>
  <div class="guide">
    <div class="container">
      <div class="sharing_title">
        <img src="../../img/guide.svg" alt="海外就業指南標題icon" />
        <h3 :style="{ fontSize: fontSize.h3 + 'em' }">海外就業指南</h3>
      </div>
      <ul class="guide_wrap">
        <li class="guide_group" v-for="message in guides" :key="message.pageId">
          <a
            class="guide_item"
            :href="message.pageContent"
            :title="'[另開新視窗]' + message.nodeName"
            target="_blank"
          >
            <div class="pic">
              <template
                v-for="(image, index) in message.imageFiles"
                :key="index"
              >
                <img :src="image.filePath" :alt="message.nodeName" />
              </template>
            </div>
            <div class="txt">
              <div :style="{ fontSize: fontSize.h5 + 'em' }">
                {{ message.nodeName }}
              </div>
              <p :style="{ fontSize: fontSize.p + 'em' }">
                {{ message.pageTitle }}
              </p>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="guideRWD">
    <a-carousel :after-change="onChange">
      <!-- clickBox是每頁顯示的筆數 -->
      <div v-for="clickBox in totalPageNum" :key="clickBox">
        <ul
          class="guide_wrap"
          v-for="(message, index) in guides"
          :key="message.pageId"
        >
          <li
            class="guide_group"
            v-if="
              index < clickBox * pageCount &&
              index >= (clickBox - 1) * pageCount
            "
          >
            <a
              class="guide_item"
              :href="message.pageContent"
              :title="'[另開新視窗]' + message.nodeName"
              target="_blank"
            >
              <template
                v-for="(image, index) in message.imageFiles"
                :key="index"
              >
                <img :src="image.filePath" :alt="message.nodeName" />
              </template>
              <div class="txttt">
                <p :style="{ fontSize: fontSize.p + 'em' }">
                  {{ message.nodeName }}
                </p>
                <p :style="{ fontSize: fontSize.p + 'em' }">
                  {{ message.pageTitle }}
                </p>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </a-carousel>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { defineComponent, reactive, ref, inject } from "vue";
import { apiGuide } from "@/api/api.js";
export default defineComponent({
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    const pageCount = 4;
    const guides = reactive([]);
    const totalPageNum = ref();
    apiGuide()
      .then((res) => {
        res.data.forEach((i) => {
          guides.push(i);
        });
        totalPageNum.value = Math.ceil(guides.length / pageCount);
      })
      .catch((err) => {
        console.log("海外就業指南資訊失敗", err);
      });

    const onChange = (current) => {};

    return {
      guides,
      onChange,
      pageCount,
      totalPageNum,
      fontSize,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sharing_title {
  img {
    width: 6%;
  }
}
.guide {
  .container {
    .guide_wrap {
      display: flex;
      flex-wrap: wrap;
      @include md {
        justify-content: center;
      }
      @include sm {
        flex-direction: column;
        display: none;
      }
      .guide_group {
        @include flex;
        text-align: center;
        transition: 0.1s all;
        border: rgb(231, 231, 231) 3px dashed;
        width: 24%;
        padding: 5px 15px;
        margin: 10px 5px;
        &:hover {
          border: 3px dashed $main_color;
        }
        @media screen and(max-width: 1670px) {
          width: 31%;
        }
        @include xl {
          justify-content: center;
        }
        @include md {
          width: 45%;
        }
        @include sm {
          border: 3px dashed $main_color;
          width: 100%;
          margin: 6px 0;
        }
        .guide_item {
          display: flex;
          justify-content: flex-start;
          @include xl {
            flex-direction: column;
          }
          @include sm {
            flex-direction: unset;
            border: none;
            justify-content: initial;
            margin: 10px 0;
          }
          .pic {
            width: 30%;
            @include xl {
              width: 60%;
              align-self: center;
            }
          }
          p {
            font-size: 0.813em;
          }
          .txt {
            text-align: left;
            display: flex;
            flex-direction: column;
            align-self: center;
            @include xl {
              margin-bottom: 10px;
              padding-right: 0px;
              text-align: center;
            }
            @include sm {
              text-align: left;
              margin-bottom: 0px;
            }
            h4 {
              @media screen and(max-width: 1440px) {
                font-size: $p;
              }
              @include sm {
                font-size: $h3;
              }
            }
            p {
              @include sm {
                font-size: $h4;
              }
            }
          }
        }
      }
    }
  }
}
.guideRWD {
  display: none;
  @include sm {
    display: block;
  }
  .guide_wrap {
    @include sm {
      flex-direction: column;
    }
    .guide_group {
      padding: 0 15px;
      @include sm {
        border: 3px dashed $main_color;
        width: 100%;
        margin: 6px 0;
        img {
          width: 70px;
        }
      }
      .guide_item {
        display: flex;
        align-items: center;
        height: 85px;
        @include sm {
          flex-direction: unset;
          border: none;
          justify-content: initial;
          // margin: 10px 0;
        }
        .txttt {
          display: flex;
          flex-direction: column;
          transform: translateY(8px);
          @include sm {
            text-align: left;
            margin-top: 0px;
          }
          p {
            position: relative;
            top: -10px;
            @include sm {
              font-size: $h4;
            }
          }
        }
      }
    }
  }
}
/* For demo */
.ant-carousel :deep(.slick-slide) {
  text-align: center;
  border: none;
  height: unset;
  line-height: 160px;
  background: #ffffff;
  overflow: hidden;
}
.ant-carousel :deep(.slick-slide h3) {
  color: #fff;
}
.ant-carousel :deep(.slick-dots li button) {
  background-color: $hr_gray;
  height: 8px;
  width: 65px;
}
.ant-carousel :deep(.slick-dots li.slick-active button) {
  background-color: $main_sec_color;
}

//設定高度
.ant-carousel :deep(.slick-slider) {
  height: 455px;
  border: none;
}
</style>
